var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sizes.length
    ? _c(
        "div",
        { class: ["select-size", { "select-size-empty": !_vm.sizeSelected }] },
        [
          _vm.label
            ? _c(
                "div",
                { staticClass: "select-size-label" },
                [
                  _c("div", { domProps: { textContent: _vm._s(_vm.label) } }),
                  _vm._t("default")
                ],
                2
              )
            : _vm._e(),
          _c(
            "ul",
            { staticClass: "select-size-sizes" },
            _vm._l(_vm.sizes, function(s) {
              return _c("li", {
                key: s.id,
                class: {
                  outofstock: !s.available,
                  active: _vm.checkSizeActive(s),
                  pickup: _vm.checkPickupStatus(s)
                },
                domProps: { textContent: _vm._s(s.size) },
                on: {
                  click: function($event) {
                    return _vm.select(s)
                  },
                  mouseover: function($event) {
                    return _vm.toggleHint(s)
                  },
                  mouseout: function($event) {
                    return _vm.toggleHint()
                  }
                }
              })
            }),
            0
          ),
          _vm.visibleHint
            ? _c(
                "div",
                { staticClass: "select-size-hint" },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.contentIsValid && _vm.contentIsVisible,
                            expression: "contentIsValid && contentIsVisible"
                          }
                        ]
                      },
                      [
                        _c("b", [_vm._v(_vm._s(_vm.currentSize))]),
                        _vm._v(
                          " есть в наличии только в " +
                            _vm._s(_vm.availableStores) +
                            "\n        " +
                            _vm._s(
                              _vm._f("decl")(_vm.availableStores, "магазин", [
                                "е",
                                "ах",
                                "ах"
                              ])
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }